/** Maps an HTTP status of a failed Load to a full i18n key. */
export function loadErrorKey(status: number | null | undefined): string {
  switch (status) {
    case 404:
      return 'EXTERNAL_SCENES.ERROR_LOAD_NOT_FOUND';
    case 409:
      return 'EXTERNAL_SCENES.ERROR_LOAD_CONFLICT';
    case 429:
      return 'EXTERNAL_SCENES.ERROR_LOAD_TOO_MANY';
    case 502:
      return 'EXTERNAL_SCENES.ERROR_LOAD_PROVIDER';
    default:
      return 'EXTERNAL_SCENES.ERROR_LOAD_GENERIC';
  }
}

/** Maps an HTTP status of a failed Search to a full i18n key. */
export function searchErrorKey(status: number | null | undefined): string {
  switch (status) {
    case 400:
      return 'EXTERNAL_SCENES.ERROR_SEARCH_BAD_REQUEST';
    case 404:
      return 'EXTERNAL_SCENES.ERROR_SEARCH_REGION_NOT_FOUND';
    case 502:
      return 'EXTERNAL_SCENES.ERROR_SEARCH_PROVIDERS';
    default:
      return 'EXTERNAL_SCENES.ERROR_SEARCH_GENERIC';
  }
}
